module.exports = __webpack_public_path__ + "img/box3_img3_dark.fbb012cf.png";